// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"334ffa5a","24":"0e20f6e1","66":"9a899c8e","168":"b69a53fa","199":"51c88d51","390":"7e2379da","963":"f7fdef67"}[chunkId] + ".chunk.js";
};